import { render, staticRenderFns } from "./PresentationMedia.vue?vue&type=template&id=1456c5ea&scoped=true&"
import script from "./PresentationMedia.vue?vue&type=script&lang=js&"
export * from "./PresentationMedia.vue?vue&type=script&lang=js&"
import style0 from "./PresentationMedia.vue?vue&type=style&index=0&id=1456c5ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1456c5ea",
  null
  
)

export default component.exports